 
import { call, select, takeLatest } from 'redux-saga/effects';
import { actions, selectAuthState } from './auth.slice';
import { UserRoles } from '@dynamika-shared/types/auth';
import { AuthSetUserAction, AuthSetUserRoleAction } from './auth.types';
import { IntercomInstance } from 'src/Intercom.config';
import { dispatch } from '../helpers';
import { LocalStorage, SessionStorage } from 'src/utils/storage';
import { getEnvVariables } from 'src/env';

export const persistent_key = 'userStore_selectedRole';

export const getLastSelectedUser = () => {
  return LocalStorage.getItem(persistent_key) as UserRoles | null;
};

export const removeSelectedUser = () => {
  LocalStorage.setItem(persistent_key, '');
  Object.keys(LocalStorage).forEach(key => {
    if (/@@auth0/.test(key)) {
      LocalStorage.removeItem(key);
      SessionStorage.clear();
      document.cookie = '';
    }
  });
};

export function* setUserWorker(action: AuthSetUserAction) {
  const user = action.payload;

  const persistedRole: UserRoles | null = yield call(getLastSelectedUser);

  const metaData = user?.['dynamika7/user_metadata'];
  const roles = metaData?.roles;
  const user_id = metaData?.uuid;
  const user_hash = user?.intercom;
  const role = roles?.[0];
  const persistedRoleIsValid =
    persistedRole && roles?.find(role => role === persistedRole);

  const userData = {
    ...user,
    selectedRole: persistedRoleIsValid ? persistedRole : role,
  };

  yield dispatch(actions.setUserDone(userData));

  const { ENVIRONMENT } = yield call(getEnvVariables);

  yield call(IntercomInstance.getInstance().boot, {
    ...user,
    user_hash,
    user_id,
    environment: ENVIRONMENT,
    role,
  });
}
export function* setUserRoleWorker(action: AuthSetUserRoleAction) {
  const role = action.payload;
  yield call(LocalStorage.setItem, persistent_key, role);
  const state: ReturnType<typeof selectAuthState> =
    yield select(selectAuthState);

  if (state.data) {
    const userData = {
      ...state.data,
      selectedRole: role,
    };
    yield dispatch(actions.setUserRoleDone(userData));
  }
}

export function* clearUserWorker() {
  yield call(removeSelectedUser);
  yield call(IntercomInstance.getInstance().shutdown);
}

export function* authSaga() {
  yield takeLatest(actions.setUser.type, setUserWorker);
  yield takeLatest(actions.setUserRole.type, setUserRoleWorker);
  yield takeLatest(actions.clearUser.type, clearUserWorker);
}
